import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Grid,
    IconButton,
    Card,
    CircularProgress,
    Divider,
    Chip,
    CardMedia
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoTicketOutline } from "react-icons/io5";
import { AlertError, AlertSuccess } from '../../../../component/popupAlert';
import { ChangedStatus, CreateBoat, getboatdataById, TestUpdate } from '../../../../service/boat_service';
import { defaultBoatData } from './boatFrom_model';
import AppBarComponent from '../../../../component/appbar';
import Cookies from 'js-cookie'

const BoatForm_View = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const { id } = useParams();
    const token = Cookies.get('token');
    const [boatData, setBoatData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [createState, setCreateState] = useState(false);
    const [disableOptions, setDisableOptions] = useState(false);
    const [title, setTitle] = useState(false);
    const [image, setImage] = useState(null);
    const [tempData, setTempData] = useState();

    useEffect(() => {
        // handelGetBoatData();
        if (pathname.includes('/create')) {
            setBoatData(defaultBoatData)
            setEditMode(true);
            setCreateState(true);
            setDisableOptions(true)
            setTitle('สร้างเรือใหม่')
        } else {
            handelGetBoatData();
            setCreateState(false)

        }
    }, []);

    const handelGetBoatData = async () => {
        try {
            setLoading(true);
            const res = await getboatdataById(id);
            setTitle(res.name);
            setBoatData(res);
            setLoading(false);
        } catch (error) {
            console.error(error);
            AlertError(error);
            navigate('/404')
        }
    }

    const handleColorStatus = ()=>{
        if(boatData.status === 'ยกเลิกการใช้งาน'){
            return '#f44336'
        } else if(boatData.status === 'กำลังใช้งาน'){
            return '#4caf50'
        } else {
            return '#ff9800'
        }
    }

    const handleStatusBoat = async (status) => {
        try {
            const res = await ChangedStatus(id, status, token)
        } catch (error) {
            AlertError('อัพเดทข้อมูลผิดพลาด')
        }
        AlertSuccess('บันทึกข้อมูลเรือสำเร็จ')
        handelGetBoatData()
        // navigate('/admin/boatmanagement');
    }

    const handleImageUpload = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            const reader = new FileReader(); // Create a FileReader instance
            reader.onloadend = () => {
                setImage(file); // Set the image state to the selected file
            };
            reader.readAsDataURL(file); // Read the file as a data URL
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setBoatData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChanger = (t) => {

        setBoatData(prevState => ({
            ...prevState,
            ['image']: t
        }));
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    const handleEditMode = () => {
        setTempData(boatData);
        setEditMode(!editMode);
        if (!editMode) {
            setTempData(boatData);
        } else {
            setBoatData(tempData);
            setTempData([])
        }
    }

    if (!boatData) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Typography variant="h6">No boat data found</Typography>
            </Box>
        );
    }

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission

        try {
            let res; // Variable to hold response

            if (createState) {
                // Create a new boat
                res = await CreateBoat(boatData, image, token);
                // console.log(res);
                handleChanger(res.imageUrl); // Handle the created boat's image URL
            } else {
                // Update an existing boat
                const data = boatData
                // res = await UpdateBoat(data, image, token);
                res = await TestUpdate(id,data, token);
                // console.log('Boat updated successfully:', res);
            }

            // Show success alert
            AlertSuccess('บันทึกข้อมูลเรือสำเร็จ'); // Success message

            // Navigate to boat management page if necessary
            navigate('/thewonderblueadmin_boatmangement');

        } catch (error) {
            console.error(error);
            AlertError(error); // Show error alert
        }
    };

    return (
        <Box >
            <AppBarComponent/>
            <Box sx={{ display: 'flex', height: 'auto', bgcolor: 'white', margin: 1 }}>
                <Paper
                    elevation={3}
                    sx={{
                        m: 'auto',
                        width: '90%',
                        maxWidth: 2000,
                        height: '90%',
                        p: 2,
                        borderRadius: 4,
                        display: 'flex',
                    }}
                >
                    {/* Left sidebar */}
                    <Box sx={{ width: '25%', borderRight: '1px solid #e0e0e0', }}>
                        <Box sx={{ display: 'flex', justifyContent:'space-between' }}>
                            <Typography variant="h6" sx={{ mb: 2, color: '#1976d2', fontWeight: 'bold' }}>
                                {title}
                                <IconButton size="medium" sx={{ ml: 1 }}>
                                    <IoTicketOutline />
                                </IconButton>
                            </Typography>
                            {!createState && (<Chip label={boatData.status} variant="outlined" sx={{margin:1,color:'#FFFFFF',bgcolor:handleColorStatus(),width:'160px'}} />) }
                        </Box>
                        <Divider sx={{margin:1}}/>
                        {!createState && (
                            <Box>
                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold', fontSize: '18px', marginTop: '8px' }}>
                                    Optiona
                                </Typography>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        mt: '12px',
                                        width: '96%',
                                        borderColor: !editMode ? 'primary.main' : 'black',
                                        color: !editMode ? 'primary.main' : 'black',
                                    }}
                                    onClick={handleEditMode}
                                >
                                    {editMode === false ? "แก้ไขข้อมูลเรือ" : "ปิดการแก้ไข"}
                                </Button>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        mt: '12px',
                                        width: '96%',
                                        borderColor: 'primary.main',
                                        color: 'primary.main',
                                    }}
                                    onClick={() => handleStatusBoat("กำลังใช้งาน")}
                                >
                                    เปิดใช้งาน
                                </Button>

                                <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        mt: '12px',
                                        width: '96%',
                                        borderColor: 'primary.main',
                                        color: 'primary.main',
                                    }}
                                    onClick={() => handleStatusBoat('ส่งซ่อม')}
                                >
                                    ส่งซ่อม
                                </Button>

                                <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        mt: '12px',
                                        width: '96%',
                                        borderColor: 'red',
                                        color: 'red',
                                    }}
                                    onClick={() => handleStatusBoat('ยกเลิกการใช้งาน')}
                                >
                                    ยกเลิกการใช้งาน
                                </Button>
                            </Box>
                        )}
                    </Box>

                    {/* Main content */}
                    <Box sx={{ flexGrow: 1,width: '75%', overflowY: 'auto', maxHeight: 'calc(100vh - 100px)'  }}>
                        {/* Boat details card */}
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                รายละเอียดเรือ
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>ชื่อเรือ</Typography>
                                    <TextField
                                        fullWidth
                                        name="name"
                                        label="ชื่อ"
                                        value={boatData.name}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                            </Grid>
                        </Card>

                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Box>
                                <Typography sx={{ margin: '12px' }}>รายละเอียด</Typography>
                                <TextField
                                    fullWidth
                                    name="details"
                                    label="รายละเอียด"
                                    value={boatData.details}
                                    onChange={handleChange}
                                    multiline
                                    disabled={!editMode}
                                    minRows={3}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                        </Card>

                        {/* Boat color card */}
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                สี
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>สีไม้</Typography>
                                    <TextField
                                        fullWidth
                                        name="woodColor"
                                        label="ชื่อ"
                                        value={boatData.woodColor}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>สีไม้ด้านใน</Typography>
                                    <TextField
                                        fullWidth
                                        name="interiorColor"
                                        label="สีไม้ด้านใน"
                                        value={boatData.interiorColor}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>สีท้องเรือ</Typography>
                                    <TextField
                                        fullWidth
                                        name="hullColor"
                                        label="สีท้องเรือ"
                                        value={boatData.hullColor}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                            </Grid>
                        </Card>

                        {/* Engine details card */}
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                รายละเอียดเครื่องยนต์
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>โมเดล</Typography>
                                    <TextField
                                        fullWidth
                                        name="model"
                                        label="โมเดล"
                                        value={boatData.model}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>เครื่องยนต์</Typography>
                                    <TextField
                                        fullWidth
                                        name="engine"
                                        label="เครื่องยนต์"
                                        value={boatData.engine}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!editMode}
                                    />
                                </Grid>
                            </Grid>
                        </Card>

                        {/* Updated boat image card */}
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                                <Typography variant="h5" sx={{ mb: 2 }}>
                                    รูปเรือ
                                    <IconButton size="small">
                                        <IoMdInformationCircleOutline />
                                    </IconButton>
                                </Typography>
                                { createState && (
                                    <Button
                                        variant="contained"
                                        component="label"
                                    >
                                        อัพโหลดรูปภาพ
                                        <input
                                            type="file"
                                            hidden
                                            accept="image/*"
                                            onChange={handleImageUpload}
                                        />
                                    </Button>
                                )}
                            </Box>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            width: '100%',
                                            paddingTop: '56.25%', // 16:9 Aspect Ratio
                                            overflow: 'hidden',
                                            borderRadius: 2,
                                        }}
                                    >
                                        {boatData.image ? (
                                            <CardMedia
                                                component="img"
                                                height="500"
                                                image={"data:image/png;base64," + boatData.image}
                                                alt={boatData.name}
                                            />
                                        ) : (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    bgcolor: 'grey.300',
                                                    color: 'text.secondary',
                                                    borderRadius: 2,
                                                }}
                                            >
                                                <Typography>ไม่มีรูปภาพ</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Card>

                        {/* Back button */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                            <Button variant="outlined" sx={{ margin: 1, width: '200px' }}
                                onClick={() => navigate('/thewonderblueadmin_admin')}
                            >Back
                            </Button>
                            {editMode && (
                                <Button variant="contained" sx={{ margin: 1, width: '200px' }}
                                    onClick={handleSubmit}
                                >Save
                                </Button>)
                            }
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default BoatForm_View;